import { memo, useCallback, useTransition } from 'react';
import { useTranslation } from 'react-i18next';
import useAuth from '@/utils/auth';
import { LOGIN } from '@/Router/routes';
import LogoutIcon from '@/assets/icons/logout.svg?react';
import Link from '@/components/Link/Link';

import styles from './LogoutButton.module.scss';

type Props = {
  className?: string;
};

// eslint-disable-next-line react-refresh/only-export-components
export default memo(function LogoutButton({ className }: Props) {
  const { t } = useTranslation('menu');
  const { keycloakLogout } = useAuth();
  const [pending, startPending] = useTransition();

  const onLogout = useCallback(() => {
    const loginUrl = `${window.location.protocol}//${window.location.host}${LOGIN}`;
    startPending(() => {
      keycloakLogout(import.meta.env.VITE_STATIC_HOMEPAGE || loginUrl);
    });
  }, []);

  return (
    <Link
      disabled={pending}
      onClick={onLogout}
      dataTest="desktopHeader-link-logout"
      className={className}
    >
      <span data-test="desktopHeader-text-logout">{t('logout')}</span>
      <LogoutIcon
        className={styles.logout}
        data-test="desktopHeader-icon-logout"
      />
    </Link>
  );
});
